import React from 'react';
import Container from '@amzn/awsui-components-react/polaris/container';
import Header from '@amzn/awsui-components-react/polaris/header';
import Box from '@amzn/awsui-components-react/polaris/box';
import SpaceBetween from '@amzn/awsui-components-react/polaris/space-between';
import Spinner from '@amzn/awsui-components-react/polaris/spinner';
import { useAnalyticsData } from '../../../hooks';

const TranscriptionMetrics: React.FC = () => {
  const { data, loading, error } = useAnalyticsData();

  if (loading) {
    return (
      <Container>
        <Box textAlign="center" padding="l">
          <Spinner />
        </Box>
      </Container>
    );
  }

  if (error) {
    return (
      <Container>
        <Box color="text-status-error" textAlign="center" padding="l">
          Error loading transcription data
        </Box>
      </Container>
    );
  }

  const totalJobs = (data && data.completeSummary && data.completeSummary.totalJobs) || 0;
  const successfulJobs = (data && data.completeSummary && data.completeSummary.successfulJobs) || 0;
  const failedJobs = (data && data.completeSummary && data.completeSummary.failedJobs) || 0;
  const successRate = totalJobs > 0 ? Math.round((successfulJobs / totalJobs) * 100) : 0;

  return (
    <Container
      header={
        <Header variant="h2">
          Transcription Performance (All Time)
        </Header>
      }
    >
      <SpaceBetween direction="vertical" size="m">
        <Box>
          <Box variant="awsui-key-label">Success Rate</Box>
          <Box fontSize="heading-xl" fontWeight="bold" color="text-status-success">
            {successRate}%
          </Box>
        </Box>

        <SpaceBetween direction="vertical" size="xs">
          <Box>
            <Box variant="small">Successful Jobs</Box>
            <Box fontWeight="bold">{successfulJobs.toLocaleString()}</Box>
          </Box>
          
          <Box>
            <Box variant="small">Failed Jobs</Box>
            <Box fontWeight="bold" color="text-status-error">{failedJobs.toLocaleString()}</Box>
          </Box>
          
          <Box>
            <Box variant="small">Total Jobs</Box>
            <Box fontWeight="bold">{totalJobs.toLocaleString()}</Box>
          </Box>
        </SpaceBetween>
      </SpaceBetween>
    </Container>
  );
};

export default TranscriptionMetrics;
